import { combineReducers } from 'redux';
import app from './app/index.tsx';
import boards from './boards/index.tsx';
import query from './query/index.tsx';

export default combineReducers({
	app,
	boards,
	query,
});
